(function() {
  define('bazemont/documents/item',['angular'], function() {
    'use strict';
    return angular.module('bazemontDocumentsItem', []).component('bazemontDocumentsItem', {
      templateUrl: '/assets/javascripts/bazemont/documents/item.html',
      bindings: {
        document: '=',
        index: '<',
        first: '<',
        last: '<',
        nbColumns: '<'
      },
      require: {
        parent: '^^bazemontDocumentsList'
      },
      controller: [
        '$http', 'TlhImageService', 'TlhConfirmModalService', 'TlhGridClassService', function($http, TlhImageService, TlhConfirmModalService, TlhGridClassService) {
          var getDocumentIcon, vm;
          vm = this;
          vm.documentIcon = null;
          vm.columnClass = TlhGridClassService.getColumnClass(vm.nbColumns);
          vm.$onInit = function() {
            return $http.get('/api/admin/documents/mimetype-icon-class-mapping', {
              cache: true
            }).then(function(response) {
              var mimeTypeIconClassMapping;
              mimeTypeIconClassMapping = response.data;
              return vm.documentIcon = getDocumentIcon(mimeTypeIconClassMapping);
            });
          };
          vm.moveUp = function() {
            return vm.parent.moveDocumentUp(vm.document);
          };
          vm.moveDown = function() {
            return vm.parent.moveDocumentDown(vm.document);
          };
          vm.trash = function() {
            var message;
            message = "<p class=\"text-center\">Êtes-vous sûr(e) de vouloir supprimer le document<br><strong>" + vm.document.file.filename + "</strong> ?</p>";
            return TlhConfirmModalService.open(message).result.then(function(result) {
              if (result.confirm) {
                return vm.document.isActive = false;
              }
            });
          };
          getDocumentIcon = function(mapping) {
            var documentIcon, mimeType;
            documentIcon = null;
            if (vm.document && vm.document.file && mapping) {
              mimeType = vm.document.file.mimeType;
              documentIcon = mapping[mimeType];
              if (!documentIcon && TlhImageService.isImageType(mimeType)) {
                documentIcon = mapping['gen-picture-file'];
              }
            }
            if (!documentIcon) {
              documentIcon = mapping['gen-file'];
            }
            return documentIcon;
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=item.js.map
;
